<template>

    <div class="home">
        <HeaderUI/>
        <main class="page-main">
            <div class="page-container">
                <div class="hero">
                    <h1 class="hero-title">OaitsTools</h1>
                    <p class="hero-sub">Внутренние инструменты для работы с IT-инфраструктурой</p>
                </div>

                <div class="grid-2" v-if="is_authenticated">
                    <router-link to="/inv" class="tool-card">
                        <div class="tool-icon">
                            <AppIcon name="inv" class="tool-icon-svg"/>
                        </div>
                        <div class="tool-title">Инвентаризация IT</div>
                        <div class="tool-text">Учёт техники и оборудования</div>
                    </router-link>

                    <router-link to="/gen" class="tool-card">
                        <div class="tool-icon">
                            <AppIcon name="generator" class="tool-icon-svg"/>
                        </div>
                        <div class="tool-title">Генератор актов</div>
                        <div class="tool-text">Формирование Word-актов приёма-передачи ТМЦ</div>
                    </router-link>

                    <router-link to="/dash" class="tool-card">
                        <div class="tool-icon">
                            <AppIcon name="dash" class="tool-icon-svg"/>
                        </div>
                        <div class="tool-title">Дашборд</div>
                        <div class="tool-text">Общая статистика и активность</div>
                    </router-link>
                </div>

                <section class="card news-card" v-else>
                    <div class="card-header">
                        <div class="card-title">
                            <AppIcon name="trophy" class="card-title-icon"/>
                            Новости и обновления
                        </div>
                    </div>
                    <div class="card-body news-body">
                        <article class="news-item" v-for="news in news_items" :key="news.id">
                            <div class="news-head">
                                <span class="news-title">{{ news.title }}</span>
                                <span class="news-date">{{ news.date }}</span>
                            </div>
                            <p class="news-text">{{ news.text }}</p>
                        </article>
                    </div>
                    <div class="card-footer news-footer">
                        <router-link to="/auth" class="news-login-link">Войти или создать аккаунт, чтобы открыть инструменты</router-link>
                    </div>
                </section>
            </div>
        </main>
    </div>

</template>


<script>

import HeaderUI from '../components/HeaderUI.vue'
import AppIcon from '../components/AppIcon.vue'
import { checkAuth } from '../auth/auth.js'

export default {
    name: 'HomeView',

    components: {
        HeaderUI,
        AppIcon
    },

    data() {
        return {
            is_authenticated: checkAuth(),
            news_items: [
                {
                    id: 1,
                    date: '03.09.2026',
                    title: 'Акты теперь в формате Word',
                    text: 'Генератор актов формирует DOC-файлы: блоки «Сдал / Принял», шапка таблицы и надпись внизу автоматически повторяются на каждой странице документа.'
                },
                {
                    id: 2,
                    date: '02.09.2026',
                    title: 'Предпросмотр документов',
                    text: 'Сгенерированные акты можно посмотреть прямо в браузере из истории генераций, не скачивая файл.'
                },
                {
                    id: 3,
                    date: '01.09.2026',
                    title: 'Закрытые инструменты',
                    text: 'Инвентаризация IT, генератор актов и дашборд теперь доступны только авторизованным пользователям.'
                }
            ]
        }
    }
}

</script>


<style scoped>

.home{
    width: 100%;
    min-height: 100vh;

    display: flex;
    flex-direction: column;
}

.hero{
    text-align: center;

    margin-bottom: 32px;
}

.hero-title{
    font-size: 32px;
    font-weight: 700;
    letter-spacing: -0.03em;
}

.hero-sub{
    margin-top: 8px;

    font-size: 15px;
    color: var(--muted-foreground);
}

.tool-card{
    display: block;

    padding: 20px;

    background: var(--card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    box-shadow: var(--shadow-sm);

    text-decoration: none;

    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.tool-card:hover{
    border-color: #d4d4d8;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
}

.tool-icon{
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 38px;
    height: 38px;

    margin-bottom: 12px;

    background: var(--muted);
    border: 1px solid var(--border);
    border-radius: 8px;

    color: var(--foreground);
}

.tool-icon-svg{
    width: 18px;
    height: 18px;
}

.tool-title{
    font-size: 15px;
    font-weight: 600;

    color: var(--foreground);
}

.tool-text{
    margin-top: 4px;

    font-size: 13px;
    color: var(--muted-foreground);
}

/* --- Новости для неавторизованных --- */

.news-card{
    max-width: 640px;

    margin: 0 auto;
}

.news-body{
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.news-item{
    padding-bottom: 16px;

    border-bottom: 1px solid var(--border);
}

.news-item:last-child{
    padding-bottom: 0;
    border-bottom: none;
}

.news-head{
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
}

.news-title{
    font-size: 14px;
    font-weight: 600;
}

.news-date{
    font-size: 12px;
    color: var(--muted-foreground);

    white-space: nowrap;
}

.news-text{
    margin-top: 6px;

    font-size: 13px;
    line-height: 1.5;
    color: var(--muted-foreground);
}

.news-footer{
    text-align: center;
}

.news-login-link{
    font-size: 13px;
    font-weight: 500;
    color: var(--foreground);
}

</style>
